import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {browserHistory} from 'react-router';

import {removeProductFromCart} from '../../ducks/cart';
import {closeModal} from '../../ducks/ui';

import CartModal from '../../components/modals/CartModal';
import withChannelFormatters from '../channelUtils/withChannelFormatters';

@withChannelFormatters
@connect(({cart}) => ({cart}))
export default class CartModalContainer extends React.PureComponent {
  static modalName = 'cart';

  render() {
    const {dispatch, cart, channelFormatters, ...rest} = this.props;

    return (
      <CartModal
        cart={cart}
        onRemove={(itemId) => dispatch(removeProductFromCart(itemId))}
        onCheckout={() => {
          dispatch(closeModal());
          browserHistory.push(channelFormatters.link('/checkout'));
        }}
        {...rest}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./containers/cartModalContainer/CartModalContainer.js